import module1 from './module1'
import module2 from './module2'

// 商城
const moduleMall = [
  ...module1,
  ...module2,
]
export default moduleMall



// WEBPACK FOOTER //
// ./src/router/module/index.js